<template>
  <HeraConfirm
    v-bind="{
      title,
      cancelButtonText,
      confirmButtonText,
      isLoading,
    }"
    v-on="$listeners"
  >
    <TextBlock tag="p" variant="secondary" class="text-left">
      {{
        $t(
          '_web_tournament_pause_modal-text',
          `Changing tournament status allows you to edit brackets on 'Publish Brackets' and then republish your tournament`
        )
      }}
    </TextBlock>
    <TextBlock tag="p" variant="secondary" class="text-left">
      {{ $t('_web_tournament_pause_modal-notes-text', 'Please note:') }}<br />
      {{
        $t(
          '_web_tournament_pause_modal-text-note-1',
          'Resetting brackets with already completed matches will erase existing results. There is no undo.'
        )
      }}
    </TextBlock>
    <TextBlock tag="p" variant="secondary" class="text-left">{{
      $t(
        '_web_tournament_pause_modal-text-note-2',
        'Once brackets are reset, matches can be edited manually.'
      )
    }}</TextBlock>
  </HeraConfirm>
</template>

<script>
import HeraConfirm from './HeraConfirm';
import TextBlock from '@/components/atoms/TextBlock';
export default {
  name: 'TournamentPauseModal',
  components: { HeraConfirm, TextBlock },

  props: {
    title: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonText: {
      type: [String, Boolean],
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
